import { render, staticRenderFns } from "./LinkSupport.vue?vue&type=template&id=5194897e&scoped=true&"
import script from "./LinkSupport.vue?vue&type=script&lang=js&"
export * from "./LinkSupport.vue?vue&type=script&lang=js&"
import style0 from "./LinkSupport.vue?vue&type=style&index=0&id=5194897e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194897e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLinkWr: require('/app/components/base/LinkWr.vue').default})
